/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_User_Administered_By_TomorrowInputs */

const en_error_user_administered_by_tomorrow = /** @type {(inputs: Error_User_Administered_By_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow gave this user a role your company doesn't give: ask your contact at Tomorrow to change it.`)
};

/**
* | output |
* | --- |
* | "Tomorrow gave this user a role your company doesn't give: ask your contact at Tomorrow to change it." |
*
* @param {Error_User_Administered_By_TomorrowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_user_administered_by_tomorrow = /** @type {((inputs?: Error_User_Administered_By_TomorrowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_User_Administered_By_TomorrowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_user_administered_by_tomorrow(inputs)
});